import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    TaxesServiceProxy, CreateOrEditTaxDto, TaxMappingEditDto,
    DropDownLookupDto, CommonLookupServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-tax.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditTaxComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    tax: CreateOrEditTaxDto = new CreateOrEditTaxDto();
    taxMapping: TaxMappingEditDto =  new TaxMappingEditDto();
    allDepartments: DropDownLookupDto[];
    allCategories: DropDownLookupDto[];
    allLocations: DropDownLookupDto[];
    allProducts: DropDownLookupDto[];
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Tax'), '/app/master/taxes'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _taxesServiceProxy: TaxesServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _commonLookupService: CommonLookupServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    removeItem(index: number) {
        this.tax.taxMapping.splice(index, 1);
       
        if (this.tax.taxMapping.length == 0) {
            this.addRow();
        }
        
    }


    addRow(): void{

        if (this.tax.taxMapping == null)
            this.tax.taxMapping = [];


        this.taxMapping = new TaxMappingEditDto();
        this.taxMapping.departmentId = null;
        this.taxMapping.categoryId = null;
        this.taxMapping.productId = null;
        this.taxMapping.locationId = null;
        this.tax.taxMapping.push(this.taxMapping);

       
        
    }

    show(taxId?: number): void {
        this.tax.taxMapping = [];
        if (!taxId) {
            this.tax = new CreateOrEditTaxDto();
            this.tax.id = taxId;
            this.tax.taxMapping = [];
            this.active = true;
        } else {
            this._taxesServiceProxy.getTaxForEdit(taxId).subscribe((result) => {
                this.tax = result.tax;
                this.tax.taxMapping = result.taxMapping;

                if (this.tax.taxMapping.length == 0) {
                    this.addRow();
                }
                this.active = true;
            });
        }
        
        if (this.tax.taxMapping.length == 0) {
            this.addRow();
        }

        this._commonLookupService.getAllDepartmentForTableDropdown().subscribe((result) => {
            this.allDepartments = result;
        });

        this._commonLookupService.getAllLocationForTableDropdown().subscribe((result) => {
            this.allLocations = result;
        });

        this._commonLookupService.getAllCategoryForTableDropdown().subscribe((result) => {
            this.allCategories = result;
        });

        this._commonLookupService.getAllProductsForTableDropdown().subscribe((result) => {
            this.allProducts = result;
        });
    }

    save(): void {
        this.saving = true;

        console.log(this.tax);
        const allColumnsNull = this.tax.taxMapping.every(row =>
            Object.values(row).every(value => (value == null || value == 'null')) // == covers null & undefined
        );

        if (allColumnsNull) {
            this.tax.taxMapping = null;
        }

        this._taxesServiceProxy
            .createOrEdit(this.tax)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/master/taxes']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._taxesServiceProxy
            .createOrEdit(this.tax)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.tax = new CreateOrEditTaxDto();
            });
    }
    goBack(): void {
        this._router.navigate(['/app/master/locations']);
    }
}
